// we cannot use the `Message` type from the SDK here because we will
// be writing this code before we upgrade to a new SDK version but they _should_

import { z } from "zod";

import { ItemEditorLtiEventSchema } from "./item-editor";

export const ItemBrowserLtiEvents = {
  ITEM_BROWSER_CLOSED: "itemBrowserClosed",
  ITEM_HAS_UNSAVED_CHANGES: "itemHasUnsavedChanges",
  ITEM_SELECTED: "itemSelected",
  LAUNCHED: "launched",
} as const;

export const ItemBrowserLtiEventSchema = z.union([
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemBrowserLtiEvents.LAUNCHED),
    data: z.optional(z.unknown()),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemBrowserLtiEvents.ITEM_BROWSER_CLOSED),
    data: z.optional(z.unknown()),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemBrowserLtiEvents.ITEM_SELECTED),
    data: z.object({
      id: z.string(),
    }),
  }),
  ItemEditorLtiEventSchema,
]);

export type ItemBrowserLtiEvent = z.infer<typeof ItemBrowserLtiEventSchema>;
